<div class="bg-shui-base-3 rounded-md pt-4">
    <main class="p-4 flex gap-2">
        <sh-icon icon="success"></sh-icon>
        <div class="flex flex-col">
            <p class="text-shui-text-strong text-2xl font-sh-bree-headline m-0 p-0">
                {{ 'request.issueReportDialog.title-head' | translate }}
            </p>
            <p class="text-shui-text-strong text-xl m-0 p-0">
                {{ 'request.issueReportDialog.title-tail' | translate: { displayId: 'MDLA-' + data.displayId } }}
            </p>
        </div>
    </main>

    <div class="flex justify-end items-center p-4">
        <sh-button
            data-testid="create-dialog-button-go-back"
            [label]="'request.issueReportDialog.goBack' | translate"
            icon="arrow-line-right-s"
            [attr.icon-position]="'right'"
            layout="normal"
            size="max-content"
            [routerLink]="'/'"
        ></sh-button>
    </div>
</div>
